import React from 'react';
import _ from 'lodash'
import NumberFormat from 'react-number-format';

// interface NumberFormatCustomProps {
//     inputRef: (instance: NumberFormat | null) => void;
//     onChange: (event: { target: { name: string; value: string } }) => void;
//     name: string;
// }

// export function NumberFormatCustom2(props: NumberFormatCustomProps) {
//     const { inputRef, onChange, ...other } = props;

//     return (
//         <NumberFormat
//             {...other}
//             getInputRef={inputRef}
//             onValueChange={(values) => {
//                 onChange({
//                     target: {
//                         name: props.name,
//                         value: values.value,
//                     },
//                 });
//             }}

//         />
//     );
// }


interface CustomProps {
    onChange: (event: { target: { name: string; value: string } }) => void;
    name: string;
}
// @ts-ignore
export const NumberFormatCustom = React.forwardRef<NumberFormat, CustomProps>(
    function NumberFormatCustom(props, ref) {
        const { onChange, ...other } = props;
        // console.log("other",other)
        return (
            <NumberFormat
                {...other}
                getInputRef={ref}
                onValueChange={(values) => {
                    
                    onChange({
                        target: {
                            name: props.name,
                            value: values.value,
                        },
                    });
                }}

            />
        );
    },
);



export default NumberFormatCustom


